import HeroSection from "../HeroSection";
import Navbar from "../Navbar";
import DotGroup from "../../../Components/DotGroup"
import MySkills from "../MySkills";
import AboutMe from "../AboutMe";
import MyPortfolio from "../MyPortfolio";
import ContactMe from "../ContactMe";
import Footer from "../Footer";

export default function Home (){

    const sections = [
        { id: "heroSection" },
        { id: "mySkills" },
        { id: "MyPortfolio" },
        { id: "AboutMe" },
        { id: "Contact" },
      ];

    return (
        <>
        <HeroSection />
        <Navbar />
        <DotGroup sections={sections} />
        <MySkills />
        <MyPortfolio />
        <AboutMe />
        <ContactMe />
        <Footer />
        </>
        )
}